/* eslint quotes:0 */
const lengthLimits = {
  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ //
  // TODO: All of these entries below need to be updated to reflect the
  // actual PIPE description `r0` (not the dropdown label), otherwise, we
  // can't use them to look anything up.
  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ //
  /*
  "56 Trailer (Semi-Trailer) drawn only by GVW Series truck tractors on 5th wheel, any weight": {
    min: 0,
    max: Number.MAX_VALUE,
  },
  "62 Camp trailers, constructed with folding walls": {
    min: 0,
    max: Number.MAX_VALUE,
  },
  "77 Travel Trailer, up to 35 ft.": {
    min: 0,
    max: 35,
  },
  "78 Travel Trailers over 35, License plate, not affixed to property": {
    min: 36,
    max: Number.MAX_VALUE,
  },
  "51 HS up to 35' length": {
    min: 0,
    max: 35,
  },
  "51 HS over 35' thru 40' length": {
    min: 36,
    max: 40,
  },
  "51 HS over 40' thru 45' length": {
    min: 41,
    max: 45,
  },
  "51 HS over 45' thru 50' length": {
    min: 46,
    max: 50,
  },
  "51 HS over 50' thru 55' length": {
    min: 51,
    max: 55,
  },
  "51 HS over 55' thru 60' length": {
    min: 56,
    max: 60,
  },
  "51 HS over 60' thru 65' length": {
    min: 61,
    max: 65,
  },
  "51 HS over 65' length": {
    min: 66,
    max: Number.MAX_VALUE,
  },
  "50 Non-Resident Military HS, any length": {
    min: 0,
    max: Number.MAX_VALUE,
  },
  "76 Park Trailers, all lengths": {
    min: 0,
    max: Number.MAX_VALUE,
  },
  "78 Travel Trailers over 35 (MH-TV), HS decal,affixed to property": {
    min: 36,
    max: Number.MAX_VALUE,
  },
  "76 Park Trailers (MH-PT), all lengths": {
    min: 0,
    max: Number.MAX_VALUE,
  },
  "86 (37) Real Property, HS, MH-TV, MH-PT, any length": {
    min: 0,
    max: Number.MAX_VALUE,
  },
  "100 Vessel, 1 to 11 feet in length and all canoes with motor": {
    min: 1,
    max: 11,
  },
  "100 Vessel 12 to 15 feet in length": {
    min: 12,
    max: 15,
  },
  "100 Vessel, 16 to 25 feet in length": {
    min: 16,
    max: 25,
  },
  "100 Vessel, 26 to 39 feet in length": {
    min: 26,
    max: 39,
  },
  "100 Vessel, 40 to 64 feet in length": {
    min: 40,
    max: 64,
  },
  "100 Vessel, 65 to 109 feet in length": {
    min: 65,
    max: 109,
  },
  "100 Vessel, 110+ feet in length": {
    min: 110,
    max: Number.MAX_VALUE,
  },
  */
};

export default lengthLimits;



// WEBPACK FOOTER //
// ./src/modules/data/vehicle-length-limits.js